import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../atoms/Button'
import Text from '../atoms/TextNew'
import View from '../atoms/View'
import CloseXSvg from '../other/svg/CloseXSvg'

interface DeleteIntegrationModalProps {
  isOpen: boolean
  channelName: string
  onClose: () => void
  onConfirm: () => void
}

const DeleteIntegrationModal = ({
  isOpen,
  channelName,
  onClose,
  onConfirm
}: DeleteIntegrationModalProps): JSX.Element => {
  const { t } = useTranslation()

  if (!isOpen) {
    return <></>
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-4 p-8 max-w-md w-full mx-4 bg-white shadow-bothMedium">
        <View className="flex justify-between items-center mb-6">
          <Text className="text-xl font-Bold text-darkGrey">{t('integrations_screen.disconnect_title')}</Text>
          <Button onClick={onClose} customStyles="text-grey hover:text-darkGrey !bg-white">
            <CloseXSvg className="w-6 h-6 text-darkGrey" />
          </Button>
        </View>
        <div className="mb-6">
          <Text className="font-SemiBold text-darkGrey">{channelName}</Text>
          <Text className="text-m text-grey mt-4">{t('integrations_screen.disconnect_message')}</Text>
        </div>
        <View className="flex justify-end gap-4">
          <Button onClick={onClose} color="grey" dataTestId="cancel-disconnect-integration">
            {t('integrations_screen.cancel')}
          </Button>
          <Button onClick={onConfirm} color="errorRed" dataTestId="confirm-disconnect-integration">
            {t('integrations_screen.disconnect_confirm')}
          </Button>
        </View>
      </div>
    </div>
  )
}

export default DeleteIntegrationModal
